// ===================================================================
// ⏳ COMPONENTE DE LOADING SPINNER
// ===================================================================

import React from 'react';
import { styles } from '../../styles/globalStyles';

export const LoadingSpinner = React.memo(({ text = "Carregando..." }) => (
  <div style={styles.loading}>
    <div style={styles.spinner}></div>
    <div style={styles.loadingText}>{text}</div>
  </div>
)); 